import { ALERT_VALIDATION_DECISION_LABELS } from "src/constants/alerts";
import { useT } from "src/internationalization";
import { AlertValidationDecision } from "src/types/alert";

export const useGetAlertDecisionLabel = () => {
  const t = useT();

  const getAlertDecisionLabel = (decision: AlertValidationDecision) => {
    return t(ALERT_VALIDATION_DECISION_LABELS[decision]);
  };

  return getAlertDecisionLabel;
};
